<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>{{ $t('alreadySaledVouchers') }}</v-tab>
      <v-tab>{{ $t('VoucherUsed') }}</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <voucher-statistic :current-date="$parent.dateRange" />
      </v-tab-item>
      <v-tab-item>
        <voucher-used :current-date="$parent.dateRange" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import VoucherStatistic from '@/views/AadenPages/voucher/VoucherStatistic.vue'
import VoucherUsed from '@/views/AadenPages/voucher/VoucherUsed.vue'

export default {
  name: 'VoucherIndex',
  components: {
    VoucherUsed,
    VoucherStatistic
  },
  data () {
    return {
      tab: null
    }
  },
  async mounted () {
  }
}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
